import { applicationBreadcrumbList } from "@/l-data/admin/breadcrumLists";
import Header from "../_components/Header";
import JobApplicationTable from "./_components/JobApplicationTable";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/context/apiRequest";
import TableSearch from "@/components/table_search/TableSearch";
import PaginationEl from "../_components/PaginationEl";
import TableSkeleton from "@/components/skeletons/TableSkeleton";
import ApiError from "@/components/error404/ApiError";
import { JobApplicationProps } from "@/types/admin_types";

export default function JobApplications() {

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data: messages, isLoading, isError } = useQuery({
    queryKey: ['job-applications'],
    queryFn: async () => 
    await api().get(`/api/v1/admin/applications?search=${search}&page=${search ? 1 : page}`).then((res) => {
      return res?.data?.data as JobApplicationProps;
    })
  })

  return (
    <main>
      <Header title={"Application Display"} list={applicationBreadcrumbList}/>
      <div className='flex items-center justify-between py-6'>
        <TableSearch search={search} setSearch={setSearch}/>
      </div>
      {messages && <JobApplicationTable data={messages}/>}
      {messages && <PaginationEl setPage={setPage} data={messages} />}
      {isLoading && <TableSkeleton/>}
      {isError && <ApiError/>}
    </main>

  )
}
